import * as React from "react";
import * as Helpers from "../helpers";
import { StepWizardChildProps } from "react-step-wizard";
import InputText from "../Components/InputText";
import InputSelect from "../Components/InputSelect";
import PageNavigation from "../Components/PageNavigation";
import Steps from "./steps";

export type AdditionalDetailsFields = {
    address_source: string;
    address_source_other: string;
    address_voucher: string;
}

export class AdditionalDetails extends React.Component<PageProps<AdditionalDetailsFields> & Partial<StepWizardChildProps>, PageState> {
    constructor(props: PageProps<AdditionalDetailsFields>) {
        super(props);

        this.state = {
            validation_triggered: false
        };
    }

    triggerValidation() {
        const page_fields = ["address_source", "address_voucher"];

        if (this.props.form_values.address_source === "Other") {
            page_fields.push("address_source_other");
        }

        return Helpers.TriggerValidation(this, page_fields, this.props.required, this.props.form_values);
    }

    goBack() {
        if (this.props.previousStep) {
            this.props.previousStep();
        }
    }

    submit() {
        const validation_result = this.triggerValidation();
        if (!validation_result) {
            return;
        }

        if (this.props.nextStep) {
            this.props.nextStep();
        }
    }

    render() {
        let scrolled = false;
        let getScrolled = () => scrolled;
        let setScrolled = () => { scrolled = true; };

        return <div>

            <div className="row">
                <div className="col-md-6">
                    <InputSelect
                        label="How did you hear about us?"
                        name="address_source"
                        value={this.props.form_values.address_source}
                        required={this.props.required.address_source}
                        options={[
                            { value: "Leaflets", label: "Leaflets" },
                            { value: "Magazines", label: "Magazines" },
                            { value: "Google", label: "Google" },
                            { value: "Facebook", label: "Facebook" },
                            { value: "Instagram", label: "Instagram" },
                            { value: "LinkedIn", label: "LinkedIn" },
                            { value: "Referral", label: "Referral" },
                            { value: "Directory", label: "Directory" },
                            { value: "CheckATrade", label: "CheckATrade" },
                            { value: "Bark", label: "Bark" },
                            { value: "ChatGPT", label: "ChatGPT" },
                            { value: "Other", label: "Other" }
                        ]}
                        validation_message="Please select how you heard about us."
                        validation_triggered={this.state.validation_triggered}
                        validation_get_scrolled={getScrolled}
                        validation_set_scrolled={setScrolled}
                        update_value={this.props.update_value}
                    />
                    {this.props.form_values.address_source === "Other" ? <InputText
                        label="Please specify"
                        name="address_source_other"
                        value={this.props.form_values.address_source_other}
                        required={this.props.required.address_source_other}
                        validation_message="Please specify how you heard about us."
                        validation_triggered={this.state.validation_triggered}
                        validation_get_scrolled={getScrolled}
                        validation_set_scrolled={setScrolled}
                        update_value={this.props.update_value}
                    /> : null}
                </div>
                <div className="col-md-6">
                    <InputText
                        label="Voucher Code"
                        name="address_voucher"
                        value={this.props.form_values.address_voucher}
                        required={this.props.required.address_voucher}
                        validation_message="Please enter your voucher code."
                        validation_triggered={this.state.validation_triggered}
                        validation_get_scrolled={getScrolled}
                        validation_set_scrolled={setScrolled}
                        update_value={this.props.update_value}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-md-6">
                    <Steps totalSteps={this.props.totalSteps!} currentStep={this.props.currentStep!} />
                </div>
                <div className="col-md-6">
                    <PageNavigation allowPrevious={true} allowNext={true} useSubmitForNext={false} onNext={() => this.submit()} onPrevious={() => this.goBack()}/>
                </div>
            </div>
        </div>;
    }
}